export enum SmevMonitoringColumnTypeEnum {
  RECEIVE = 'RECEIVE',
  SEND = 'SEND',
  SMEV = 'SMEV',
}
